'use client'

import { Cell, Divider, Image } from '@vinted/web-ui'

import {
  ModeratedItemAvailabilityStatus,
  ConversationModeratedItems,
} from '@marketplace-web/messaging/conversation-messaging-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import ModeratedItemCell from '../ModeratedItemCell'

type Props = {
  toggleSidebar?: () => void
  moderatedItems: ConversationModeratedItems
}

const ModeratedItemsHeader = ({ toggleSidebar, moderatedItems }: Props) => {
  const translate = useTranslate('conversation.moderated_items')

  const getHeaderBody = () => {
    const { items } = moderatedItems

    if (
      items.every(
        ({ availabilityStatus }) => availabilityStatus === ModeratedItemAvailabilityStatus.Deleted,
      )
    ) {
      return translate('header.deleted', { item: moderatedItems.itemCount })
    }

    if (
      items.every(
        ({ availabilityStatus }) => availabilityStatus === ModeratedItemAvailabilityStatus.Hidden,
      )
    ) {
      return translate('header.hidden', { item: moderatedItems.itemCount })
    }

    return translate('header.modified', { item: moderatedItems.itemCount })
  }

  const renderHeaderCell = () => {
    if (moderatedItems.itemCount === 1) return <ModeratedItemCell item={moderatedItems.items[0]!} />

    return (
      <Cell
        testId="moderated-items-header-cell"
        prefix={
          <Image
            src={moderatedItems.items[0]!.photoUrl}
            label={moderatedItems.itemCount.toString()}
            labelStyle="tight"
            ratio="square"
            styling="rounded"
            scaling="cover"
            size="large"
          />
        }
        title={translate('affected_listings')}
        body={getHeaderBody()}
        type="navigating"
        onClick={toggleSidebar}
        chevron
      />
    )
  }

  if (moderatedItems.itemCount === 0) return null

  return (
    <div data-testid="moderated-items-header">
      {renderHeaderCell()}
      <Divider />
    </div>
  )
}

export default ModeratedItemsHeader
